<script lang="ts">
    import type { TileListInitialSession } from '@tilelist/application/core/TileListInitialSession.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import LegacyHistoryController from '@tilelist/components/history/LegacyHistoryController.svelte';
    import NavigationApiHistoryController from '@tilelist/components/history/NavigationApiHistoryController.svelte';
    import ScrollRestoration from '@tilelist/components/scroll-restoration/ScrollRestoration.svelte';
    import TileListPageError from '@tilelist/components/tile-list-error/TileListPageError.svelte';
    import type { ProductItem, TileItem } from '@tilelist/domain/composition/TileListitem.ts';
    import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
    import { shouldShowTopInfos } from '@tilelist/domain/feature-visibility/TopInfoVisibility.ts';
    import TileListPage from './TileListPage.svelte';

    const {
        initialSession,
        page,
        cacheRestored,
        onRedirectToPdp,
        onProductItemUpdated,
    }: {
        initialSession: TileListInitialSession;
        page: TileListPageLayout | null;
        cacheRestored: boolean;
        onRedirectToPdp(item: TileItem): void;
        onProductItemUpdated(item: ProductItem): void;
    } = $props();

    let { onex, browser: wiring } = $derived(injectWiring());
</script>

{#if page}
    <ScrollRestoration
        isIOSApp={initialSession.session.app.isIOSApp}
        {cacheRestored}
        restoreScrollPosition={wiring?.restoreScrollPosition ?? (() => Promise.resolve())}
        saveScrollSelector={wiring?.saveScrollSelector ?? (() => {})}
    />
    {#if onex.isToggleActive('REPTILE_1303_NAVIGATION_HISTORY')}
        <NavigationApiHistoryController {initialSession} />
    {:else}
        <LegacyHistoryController {initialSession} />
    {/if}
    <TileListPage
        {...page}
        isApp={initialSession.session.app.isApp}
        showTopInfos={shouldShowTopInfos(page.context.searchContext, onex)}
        {cacheRestored}
        {onRedirectToPdp}
        {onProductItemUpdated}
    />
{:else}
    <TileListPageError />
{/if}
